module.exports = __webpack_public_path__ + "img/043-montserrat.2b60f1b7.svg";